var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tenant && _vm.user)?_c('div',{staticClass:"admin-layout"},[_c('admin-app-bar'),_c('admin-navigation-drawer'),_c('v-main',[_c('div',{staticClass:"content"},[_c('router-transition',[_c('router-view')],1)],1)])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }